<template>
  <div class="mx-2">
    <div
      class="d-flex justify-content align-items-center mb-1 cursor-pointer mt-2"
      @click="back()"
    >
      <button
        class="btn btn-sm rounded-circle p-25"
        :class="isDark ? 'btn-danger' : 'btn-primary'">
        <i class="feather icon-arrow-left arrow-icon"></i>
      </button>
      <div class="ml-1 text-capitalize text-dark goback-text">
        {{ $t("actions.go_back") }}
      </div>
    </div>
    <b-card v-if="loadingSearchRecordingRequest"  no-body>
      <div class="form-container d-flex justify-content-center align-items-center">
        <b-spinner label="Loading" variant="primary" />
      </div>
    </b-card>
    <template v-else>
      <div class="row">
        <div v-if="recordingRequestWithValidations" class="col-4">
          <div class="history-card card">
            <div class="history-header d-flex align-items-center justify-content-between">
              <strong>{{ $t('custom_forms.history') }}</strong>
              <small class="text-muted">
                {{ recordingRequestWithValidations }}
                {{ $t('custom_forms.entries') }}
              </small>
            </div>

            <div class="history-table">
              <div class="history-row history-row--head bg-transparent">
                <div class="col-state text-body">{{ $t('custom_forms.state') }}</div>
                <div class="col-user text-body">{{ $t('custom_forms.user') }}</div>
                <div class="col-date text-body">{{ $t('custom_forms.date') }}</div>
              </div>

              <div
                v-for="s in itemData.validations"
                :key="s.id"
                class="history-row-item-container">
                <div class="history-row-item">
                  <div class="col-state">
                    <b-badge pill :variant="getStatusVariant(s.status.name)" class="history-badge">
                      {{ getStatusLabel(s.status.name) }}
                    </b-badge>
                  </div>
                  <div class="col-user">
                    <div class="history-user" :title="formatUser(s)">
                      <div class="user-name text-body">{{ getUserName(s) || '—' }}</div>
                      <div v-if="getUserEmail(s)" class="user-email text-body">
                        {{ getUserEmail(s) }}
                      </div>
                    </div>
                  </div>
                  <div class="col-date">
                    <small class="history-date text-body">
                      {{ formatDate(s.approved_at || s.rejected_at || s.reopened_at || s.created_at) }}
                    </small>
                  </div>
                </div>
                <div class="history-row-item__comments">
                  {{ s.comments || s.reopened_comments }}
                </div>
              </div>
            </div>
            <!-- <div class="text-muted small py-1">
              {{ $t('custom_forms.empty') }}
            </div> -->
          </div>
        </div>
        <div :class="recordingRequestWithValidations ? 'col-8 form-container' : 'col-12'">
          <b-card no-body>
            <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
              <!-- Form -->
              <b-form
                class="p-2"
                @submit.prevent="handleSubmit(onSubmit)"
                @reset.prevent="resetForm"
              >

                <div :class="[{ 'sticky-top': recordingRequestWithValidations }, 'd-flex justify-content-between align-items-center bg-white']">
                  <h4 class="mb-0">{{ $tc("recording_request.title", 1) }}</h4>
                  <div v-if="itemData.reference_number">
                    <div class="header-grid">
                      <div class="info-card">
                        <div class="info-row">
                          <span class="info-label">{{ $t("risk.reference_number") }}:</span>
                          <span class="info-value">{{ itemData.reference_number }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-12">
                    <validation-provider #default="validationContext" name="cameras">
                      <b-form-group
                        label-for="cameras"
                        :state="getValidationState(validationContext)"
                      >
                        <template #label>
                          <div class="d-flex justify-content-between align-items-end mb-1">
                            <span>{{ $tc('camera.title', 2) }}</span>
                            <button
                              v-if="canEditForm"
                              type="button"
                              class="btn btn-sm btn-outline-primary"
                              @click="showCamerasListModal = true"
                            >
                              Agregar
                            </button>
                          </div>
                        </template>
                        <div v-if="itemData.cameras.length" class="row">
                          <div
                            v-for="(camera, index) in itemData.cameras"
                            :key="index"
                            class="col-12 d-flex mb-2"
                          >
                            <div class="rounded border-unit p-1 d-flex flex-column flex-fill">
                              <div  v-if="canEditForm" class="d-flex justify-content-end">
                                <button
                                  type="button"
                                  class="btn btn-sm p-0"
                                  @click="removeUnit(index)"
                                >
                                  <feather-icon icon="XIcon" size="20"/>
                                </button>
                              </div>
                              <p class="text-center h5 mb-1">{{ camera.unit.description }}</p>
                              <div class="row">
                                <div v-if="canEditForm" class="col-3">
                                  <div class="row">
                                    <div class="col-12">
                                      <b-form-group
                                        class="text-capitalize"
                                        :label="$t('recording_request.start')"
                                        label-for="From"
                                      >
                                        <flat-pickr
                                          id="from"
                                          v-model="camera.from"
                                          class="form-control"
                                          :config="{ enableTime: true, dateFormat: 'Y-m-d H:i:S', time_24hr: true }"
                                          :disabled="disabledInputs"
                                          @on-change="(...args) => onChangeDates('from', index, ...args)"
                                        />
                                      </b-form-group>
                                    </div>
                                    <div class="col-12">
                                      <b-form-group
                                        class="text-capitalize"
                                        :label="$t('recording_request.finish')"
                                        label-for="To"
                                      >
                                        <flat-pickr
                                          id="to"
                                          v-model="camera.to"
                                          class="form-control"
                                          :config="{ enableTime: true, dateFormat: 'Y-m-d H:i:S', time_24hr: true }"
                                          :disabled="disabledInputs"
                                          @on-change="(...args) => onChangeDates('to', index, ...args)"
                                        />
                                      </b-form-group>
                                    </div>
                                  </div>
                                </div>
                                <div :class="canEditForm ? 'col-9' : 'col-12'">
                                  <b-table
                                    small
                                    class="camera-table mb-0"
                                    :items="camera.cameras"
                                    :fields="fields"
                                    bordered
                                    sticky-header="200px"
                                  >
                                    <template #head(from)="data">
                                      <span> {{ $t(data.label) }}</span>
                                    </template>

                                    <template #cell(from)="data">
                                      <flat-pickr
                                        :id="`from-${data.item.value}`"
                                        v-model="data.item.from"
                                        class="form-control"
                                        :config="{ enableTime: true, dateFormat: 'Y-m-d H:i:S', time_24hr: true }"
                                        :disabled="disabledInputs"
                                      />
                                    </template>

                                    <template #head(to)="data">
                                      <span> {{ $t(data.label) }}</span>
                                    </template>

                                    <template #cell(to)="data">
                                      <flat-pickr
                                        :id="`from-${data.item.value}`"
                                        v-model="data.item.to"
                                        class="form-control"
                                        :config="{ enableTime: true, dateFormat: 'Y-m-d H:i:S', time_24hr: true }"
                                        :disabled="disabledInputs"
                                      />
                                      <small v-if="data.item.availabilityMessage" class="text-error d-block mt-25">
                                        {{ data.item.availabilityMessage }}
                                      </small>
                                    </template>

                                    <template #cell(actions)="data">
                                      <button
                                        type="button"
                                        class="btn btn-sm btn-danger "
                                        style="padding: 3px;"
                                        @click="removeCamerasUnit(index, data.index)"
                                      >
                                        <feather-icon icon="XIcon" size="16"/>
                                      </button>
                                    </template>
                                  </b-table>
                                </div>
                                <div class="col-12">

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else >
                          <b-alert
                            show
                            variant="warning"
                            class="p-1"
                          >
                            No se han agregado cámaras
                          </b-alert>
                        </div>
                        <div v-if="errorCameras" class="text-error">
                          {{ errorCameras }}
                        </div>
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <div class="col-6">
                    <validation-provider
                      #default="validationContext"
                      name="description"
                      rules="required"
                    >
                      <b-form-group
                        class="text-capitalize"
                        :label="$t('recording_request.description')"
                        label-for="description"
                      >
                        <b-form-input
                          id="description"
                          v-model="itemData.description"
                          :state="getValidationState(validationContext)"
                          trim
                          :disabled="disabledInputs"
                          data-cy="description"
                        />

                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <div class="col-6">
                    <validation-provider
                      #default="validationContext"
                      name="Etiqueta"
                      rules="required"
                    >
                      <b-form-group
                        class="text-capitalize"
                        :label="$t('recording_request.tag')"
                        label-for="etiqueta"
                      >
                        <v-select
                          v-model="itemData.id_tag"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="tagsOptions"
                          :clearable="false"
                          :reduce="(val) => val.value"
                          input-id="id_tag"
                          :disabled="disabledInputs"
                          data-cy="tag"
                        />
                        <b-form-invalid-feedback :state="getValidationState(validationContext)">
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <div v-if="canUserSendToReopen" class="col-6">
                    <b-form-group
                      class="text-capitalize"
                      label="Reasingar a"
                      label-for="reasignacion"
                    >
                      <v-select
                        v-model="userSelectedReasigned"
                        :options="userReopenedOptions"
                        :reduce="(user) => user.id"
                        :disabled="loading"
                        label="full_name"
                        class="comment-box mb-1"
                      >
                        <template v-slot:option="option">
                          {{ option.user }} - {{ option.full_name }}
                        </template>
                      </v-select>
                    </b-form-group>
                  </div>
                  <!-- <div class="col-12">
                    <label class="mb-2 text-capitalize">{{ $t("files") }}</label>
                    <vue-dropzone
                      id="dropzone_logo"
                      ref="dropzoneImageLogo"
                      :options="dropzoneOptions"
                      class="dropzone-main"
                      :disabled="disabledInputs"
                      @vdropzone-file-added="addFileImageLogo"
                      @vdropzone-removed-file="removeFileImageLogo"
                    />
                  </div> -->
                </div>
                  <!-- Form Actions -->
                <div class="mt-1" v-if="showSaveButton">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mr-2 text-capitalize"
                    type="submit"
                    data-cy="submit"
                    :disabled="loading || checkingAvailability"
                  >
                    <b-spinner v-if="checkingAvailability" small class="mr-50" />
                    {{ checkingAvailability ? "Validando disponibilidad..." : $t("actions.save") }}
                  </b-button>
                </div>

                <div class="mt-2" v-if="canUserSendToReview">
                  <v-select
                    v-model="userSelected"
                    :options="userOptions"
                    :placeholder="$t('custom_forms.assigned_to')"
                    :reduce="(user) => user.id"
                    class="comment-box mb-1"
                    :filter-by="filterUsers"
                    :get-option-label="getUserLabel"
                  >
                    <template v-slot:option="option">
                      {{ option.user }} - {{ option.full_name }}
                    </template>
                  </v-select>
                  <b-button
                    variant="warning"
                    class="ml-auto"
                    :disabled="!userSelected || loading"
                    @click="sendToReview()"
                  >
                    {{ $t("custom_forms.send_to_review") }}
                  </b-button>
                </div>

                <div v-if="showValidateButtons" class="mt-1">
                  <hr v-if="canUserSendToReopen" class="border">
                  <b-form-group
                    class="text-capitalize"
                    :label="$t('custom_forms.review_comments')"
                    label-for="validation_comment"
                  >
                    <b-form-textarea
                      id="validation_comment"
                      v-model="validationComment"
                      rows="3"
                      max-rows="6"
                      :disabled="loading"
                    ></b-form-textarea>
                    <div v-if="errorValidationComment" class="text-error">
                      {{ errorValidationComment }}
                    </div>
                  </b-form-group>
                  <div class="d-flex">
                    <b-button
                      variant="success"
                      class="mr-1"
                      :disabled="loading"
                      @click="approve()"
                    >
                      {{ $t("actions.approve") }}
                    </b-button>
                    <div
                      class="d-flex"
                    >
                      <b-button
                        variant="danger"
                        :disabled="loading"
                        @click="reject()"
                      >
                        {{ $t("actions.reject") }}
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-form>
            </validation-observer>
          </b-card>
        </div>
      </div>
    </template>
    <CamerasList
      :itemData="itemData"
      :showCamerasListModal="showCamerasListModal"
      :is-active.sync="showCamerasListModal"
    />
  </div>
</template>

<script>
import { computed, getCurrentInstance, onMounted ,ref } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, alphaNum, email, positive } from "@validations";
import formValidation from '@core/comp-functions/forms/form-validation';
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import axios from '@/libs/axios';
import router from '@/router';
import store from '@/store';
import CamerasList from "./CamerasList.vue";
import flatPickr from 'vue-flatpickr-component';
import vue2Dropzone from "vue2-dropzone";
import vSelect from 'vue-select';
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Ripple from "vue-ripple-directive";
import { useToast } from "vue-toastification/composition";
import { EventBus } from "@/libs/event-bus";
import moment from "moment-timezone";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    CamerasList,
    flatPickr,
    vueDropzone: vue2Dropzone,
    ValidationProvider,
    ValidationObserver,
    vSelect
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      positive,
    }
  },
  setup () {
    const vm = getCurrentInstance().proxy;

    //HOOKS
    onMounted(async () => {
      const { params } = router.currentRoute;

      if (params.id) {
        await getRecordingRequest(params.id);
      }

      await store.dispatch('bbva_request_tag/getAll');
      await getUsersReopened();
      await getValidators();
    });

    const resetData = () => {
      itemData.value = {
        id: null,
        cameras: [],
        description: '',
        from: '',
        to: '',
        id_tag: '',
        id_status: 0,
        authorized_from: null,
        authorized_to: null,
        units: [],
        schedules: [],
        validations: []
      }
    }

    //COMPOSBLES
    const { refFormObserver, getValidationState, resetForm } = formValidation(resetData);

    const { t } = useI18nUtils();

    const toast = useToast();

    //DATA
    const camerasByUnit = ref([]);

    const dropzoneImageLogo = ref(null);

    const dropzoneOptions = ref({
      url: "https://httpbin.org/post",
      paramName: "file",
      autoProcessQueue: false,
      dictDefaultMessage: "",
      addRemoveLinks: true,
      dictRemoveFile: "delete",
      acceptedFiles: "image/*, .pdf, .doc, .docx, .xlsx",
      maxFiles: 3,
    });

    const checkingAvailability = ref(false);

    const errorCameras = ref(null);

    const errorValidationComment = ref(null);

    const itemData = ref({
      id: null,
      reference_number: null,
      cameras: [],
      description: '',
      from: '',
      to: '',
      id_tag: '',
      id_status: 0,
      authorized_from: null,
      authorized_to: null,
      units: [],
      schedules: [],
      validations: [],
      last_validation: null
    });

    const loading = ref(false);

    const loadingSearchRecordingRequest = ref(false);

    const showCamerasListModal = ref(false);

    const statusesByValidator = ['approved','canceled','rejected','in_review'];

    const successProcess = ref(false);

    const userOptions = ref([]);

    const userReopenedOptions = ref([]);

    const userSelected = ref(null);

    const userSelectedReasigned = ref(null);

    const validationComment = ref(null);

    //COMPUTED
    const canEditForm = computed(() => {
      if (itemData.value.id) {
        return (formStatus.value.inProgress || formStatus.value.isReopen) && (lastStatus.value && (lastStatus.value.id_user === user.value.id))
      }

      return (formStatus.value.inProgress || formStatus.value.isReopen);
    });

    const canUserSendToReopen = computed(() => {
      const conditionReopen = formStatus.value.isReview
      //const userCanReopen   = vm.$can('reopen', 'Video');
      const userOwnerValidationForm = (lastStatus.value && lastStatus.value.id_user_validation === user.value.id);

      return (conditionReopen && userOwnerValidationForm);
    });

    const canUserSendToReview = computed(() =>  {
      const conditionForForm    = (formStatus.value.inProgress || formStatus.value.isReopen);
      const userCanSendToReview = vm.$can('request_record_video_send_to_review', 'Video');
      const userIsOwnerForm     = (lastStatus.value && (lastStatus.value.id_user === user.value.id));

      return (conditionForForm && userCanSendToReview && userIsOwnerForm && successProcess.value);
    });

    const disabledInputs = computed(() => loading.value || !canEditForm.value);

    const fields = computed(() => {
      let columns = [
        { key: 'label', label: 'Nombre', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'from', label: 'recording_request.start', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'to', label: 'recording_request.finish', thClass: 'text-center', tdClass: 'text-center'},
      ];

      if (canEditForm.value) {
        columns.push({ key: 'actions', label: ''});
      }

      return columns;
    });

    const formStatus = computed(() => {
      const currentStatus = (lastStatus.value) ? lastStatus.value.status : { name: 'in_progress'};

      return {
        withoutValue: !currentStatus ,
        inProgress: currentStatus.name === 'in_progress',
        isRejected: currentStatus.name === 'rejected',
        isApproved: currentStatus.name === 'approved',
        isReview: currentStatus.name === 'in_review',
        isReopen: currentStatus.name === 'reopened',
        isCanceled: currentStatus.name === 'canceled'
      };
    });

    const isDark = computed(() => store.state.appConfig.layout.skin === 'dark');

    const lastStatus = computed(() => itemData.value.last_validation);

    const recordingRequestWithValidations = computed(() => itemData.value.validations.length);

    const tagsOptions = computed(() => store.getters['bbva_request_tag/getSelectedItemsTag']);

    const showSaveButton = computed(() => {
      const disabledByStatuses = (formStatus.value.isReview || formStatus.value.isRejected || formStatus.value.isApproved || formStatus.value.isCanceled);
      const userCanCreate      = vm.$can('request_record_video', 'Video');
      const userCanUpdate      = vm.$can('request_record_video', 'Video');

      if (disabledByStatuses) {
        return false;
      } else if (itemData.value.id) {
        return (userCanUpdate && (lastStatus.value && (user.value.id === lastStatus.value.id_user)));
      } else {
        return (!formStatus.value.withoutValue || formStatus.value.inProgress) && userCanCreate;
      }
    });

    const showValidateButtons = computed(() => {
      const formCondition   = formStatus.value.isReview;
      const userCanValidate = vm.$can('request_record_video_validate', 'Video');
      const userOwnerValidationForm = (lastStatus.value && (lastStatus.value.id_user_validation === user.value.id));

      return (formCondition && userCanValidate && userOwnerValidationForm);
    });

    const user = computed(() => store.getters["user/getUser"]);

    //METHODS
    const addFileImageLogo = (file) => {
      dropzoneImageLogo.value = file;
    }

    const approve = async () => {
      /* errorValidationComment.value = null;

      if (!validationComment.value) {
        errorValidationComment.value = translations["testing.penetration.required"];
        return;
      } */

      const payload = {
        id_recording_request: itemData.value.id,
        comments: validationComment.value
      }

      loading.value = true;

      await axios.post('v1/recording_request/approve', payload)
        .then(response => {
          const { data } = response;

          itemData.value.last_validation = data.data.last_validation;
          itemData.value.validations = data.data.validations;

          EventBus.emit('recording-request-validated-or-rejected', { id: lastStatus.value.id, type: 'recording_request_validate'});

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          });
        })
        .finally(() => {
          loading.value = false;
        });
    }

    const back = () => {
      router.push({ name: 'recording_request' });
    }

    const buildCamerasFromApi = (cameras) => {
      const camerasMap = cameras.map(camera => camera.camera.camera);
      const units  = [];

      itemData.value.cameras = [];

      camerasMap.forEach(camera => {
        const unit = units.find(unit => (unit.id === camera.unit.id));

        if (!unit) {
          const unitData = {
            id: camera.unit.id,
            description: camera.unit.description,
            from: null,
            to: null
          }

          units.push(unitData);
        }
      });

      units.forEach(unit => {
        const camerasByUnit = cameras.filter(camera => (camera.camera.camera.unit.id === unit.id));

        if (camerasByUnit.length) {
          const dataCamera = {
            unit: null,
            cameras: []
          }

          dataCamera.unit = {
            id: unit.id,
            description: unit.description
          }

          dataCamera.cameras = camerasByUnit.map(camera => ({
            label: camera.camera.camera.name,
            value: camera.id_camera_proxy,
            from: camera.from,
            to: camera.to
          }));

          itemData.value.cameras.push(dataCamera);
        }
      });
    }

    const isCameraRangeAvailable = (options, from, to) => {
      const oldestDate = options?.oldest_recording?.start_date;
      const latestDate = options?.latest_recording?.start_date;

      if (!oldestDate && !latestDate) {
        return false;
      }

      if (oldestDate && moment(from).isBefore(moment(oldestDate))) {
        return false;
      }

      if (latestDate && moment(to).isAfter(moment(latestDate))) {
        return false;
      }

      return true;
    };

    const checkCamerasAvailability = async () => {
      const camerasToCheck = itemData.value.cameras.flatMap((unit) => unit.cameras);

      camerasToCheck.forEach((camera) => vm.$set(camera, 'availabilityMessage', null));

      if (!camerasToCheck.length) {
        return false;
      }

      const results = await Promise.all(
        camerasToCheck.map((camera) =>
          axios
            .get(`v1/services/device/get-options/${camera.value}`, {
              params: {
                withOldestRecording: true,
                withLatestRecording: true,
              },
            })
            .then((response) => ({ camera, options: response.data.data, error: false }))
            .catch(() => ({ camera, options: null, error: true }))
        )
      );

      let hasUnavailable = false;

      results.forEach(({ camera, options, error }) => {
        if (error || !options) {
          vm.$set(camera, 'availabilityMessage', 'No fue posible validar disponibilidad');
          hasUnavailable = true;
          return;
        }

        if (!isCameraRangeAvailable(options, camera.from, camera.to)) {
          const availableFrom = options?.oldest_recording?.start_date ?? '-';
          const availableTo = options?.latest_recording?.start_date ?? '-';

          vm.$set(camera, 'availabilityMessage', `Rango de fecha disponible: ${availableFrom} - ${availableTo}`);
          hasUnavailable = true;
        }
      });

      return hasUnavailable;
    };

    const checkCamerasValues = () => {
      errorCameras.value = null;

      if (!itemData.value.cameras.length) {
        errorCameras.value = 'El campo cámaras es requerido';
        return true;
      }

      const camerasWithErrorValues = itemData.value.cameras.flatMap(camera => camera.cameras)
        .some(camera => {
          const emptyValues = (!camera.from) || (!camera.to);
          const dateFrom    = moment(camera.from);
          const dateTo      = moment(camera.to);


          return (emptyValues || dateFrom.isSameOrAfter(dateTo));
        });

      if (camerasWithErrorValues) {
        errorCameras.value = 'Verique los valores de las cámaras';
      }

      return camerasWithErrorValues;
    };

    const filterUsers =(option, label, search) => {
      const text = search.toLowerCase()

      return (
        option.user?.toLowerCase().includes(text) ||
        option.full_name?.toLowerCase().includes(text)
      );
    }

    const  formatDate = (iso) => {
      if (!iso) return '';

      try {
        const d = new Date(iso);
        return d.toLocaleString();
      } catch {
        return iso;
      }
    }

    const formatUser = (s) => {
      const { name:nameStatus } = s.status;
      const historicalUser      = (statusesByValidator.includes(nameStatus)) ? s.user_validation : s.user;
      const name                = (historicalUser) ? historicalUser.user : '-';
      const email               = (historicalUser) ? historicalUser.email : '-';

      return [name, email].filter(Boolean).join(' | ');
    }

    const getRecordingRequest = async (id) => {
      loadingSearchRecordingRequest.value = true;

      await store.dispatch('recording_request/get', id)
        .then(response => {
          const { data } = response;

          itemData.value.id = data.id;
          itemData.value.reference_number = data.reference_number;
          itemData.value.description = data.description;
          itemData.value.id_tag = data.id_tag;
          itemData.value.validations = data.validations;
          itemData.value.last_validation = data.last_validation;

          buildCamerasFromApi(data.cameras);

          if (formStatus.value.inProgress || formStatus.value.isReview) {
            successProcess.value = true;
          }
        })
        .finally(() => {
          loadingSearchRecordingRequest.value = false;
        });
    }

    const getStatusLabel = (status) => {
      if (!status) return "-";

      return t(`operational_security.evaluation.status.${status}`);
    }

    const getStatusVariant = (status) => {
      if (!status) return "secondary";

      const statusVariants = {
        in_progress: "primary",
        pending: "warning",
        in_review: "info",
        completed: "success",
        rejected: "danger",
        reopened: "warning",
        approved: "success"
      };

      return statusVariants[status] || "secondary";
    }

    const getUserEmail = (s) => {
      const { name:nameStatus } = s.status;
      const historicalUser      = (statusesByValidator.includes(nameStatus)) ? s.user_validation : s.user;

      return (historicalUser) ? historicalUser.email : '-';
    }

    const getUserLabel = (option) => {
      return `${option.user} - ${option.full_name}`
    }

    const getUserName = (s) => {
      const { name:nameStatus } = s.status;
      const historicalUser      = (statusesByValidator.includes(nameStatus)) ? s.user_validation : s.user;

      return (historicalUser) ? historicalUser.user : '-';
    }

    const getUsersReopened = async () => {
      await axios.get('v1/recording_request/user-reopened')
        .then(response => {
          userReopenedOptions.value = response.data.data
        })
        .catch((error) => {
          //const errorMessage = error?.response?.data?.message ?? translations["operational_security.evaluation.status_error"];
          //contentToast(errorMessage, "danger", "AlertTriangleIcon")
        });
    }

    const getValidators = async () => {
      await axios.get('v1/recording_request/user-validators')
        .then(response => {
          userOptions.value = response.data.data
        })
        .catch((error) => {
          //const errorMessage = error?.response?.data?.message ?? translations["operational_security.evaluation.status_error"];
          //contentToast(errorMessage, "danger", "AlertTriangleIcon")
        });
    }

    const onChangeDates = (field, index, selectedDates, dateStr, instance) => {
      const dataCameras = itemData.value.cameras[index];

      dataCameras.cameras.forEach(camera => {
        camera[field] = dateStr;
      });
    }

    const onSubmit = async () => {
      const hasErrorsCameras = checkCamerasValues();

      if (hasErrorsCameras) {
        return;
      }

      checkingAvailability.value = true;

      const hasAvailabilityErrors = await checkCamerasAvailability();

      checkingAvailability.value = false;

      if (hasAvailabilityErrors) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'La petición de grabación no está disponible',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });

        return;
      }

      let dispatch;
      const data = new FormData();

      data.append("cameras", JSON.stringify(itemData.value.cameras));
      data.append("description", itemData.value.description);
      data.append("id_tag", itemData.value.id_tag);

      if (!itemData.value.id) {
      /*   const acceptedFiles = dropzoneImageLogo.value.getAcceptedFiles();

        for (let i = 0; i < acceptedFiles.length; i++) {
          if (acceptedFiles[i] instanceof File) {
            data.append(`files${i}`, acceptedFiles[i]);
          }
        }

        data.append("file_number", acceptedFiles.length); */

        dispatch = store.dispatch("recording_request/add", data);
      } else {
        data.append('_method', 'PUT');

        dispatch = store.dispatch("recording_request/edit", {
          id: itemData.value.id,
          params: data
        });
      }

      loading.value = true;

      dispatch.then((response) => {
        const { data } = response;

        if (response.success) {
          toast({
            component: ToastificationContent,
            props: {
              title: response.message,
              icon: "CheckIcon",
              variant: "success",
            },
          });

          successProcess.value = true;

          if (formStatus.value.isReopen) {
            EventBus.emit('recording-request-validated-or-rejected', { id: lastStatus.value.id, type: 'recording_request_reopened'});
          }

          if (!itemData.value.id) {
            router.push({
              name: 'recording_request_edit',
              params: {
                id: data.id
              }
            });
          }
        } else {
          toast({
            component: ToastificationContent,
            props: {
              title: response.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      })
      .catch((response) => {
        if (response.response.status == 422) {
          let string = ``;
          Object.entries(response.response.data.data).forEach((entry) => {
            const [key, value] = entry;
            string += `${key} - ${value}<br>`;
          });
          toast(
            {
              component: ToastificationContent,
              props: {
                title: `${response.response.data.message}`,
                icon: "AlertTriangleIcon",
                variant: "danger",
                text: string,
              },
            },
            {
              timeout: 10000,
            }
          );
        } else {
          toast({
            component: ToastificationContent,
            props: {
              title: response.response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }).finally(() => {
        loading.value = false;
      });
    }

    const reject = async () => {
      errorValidationComment.value = null;

      if (!validationComment.value) {
        errorValidationComment.value = 'El campo comentario es requerido';
        return;
      }

      const request = {
        id_recording_request: itemData.value.id,
        id_user_reopened: userSelectedReasigned.value,
        comments: validationComment.value
      }

      loading.value = true;

      await axios.post('v1/recording_request/reject', request)
        .then(response => {
          const { data } = response;

          itemData.value.last_validation = data.data.last_validation;
          itemData.value.validations = data.data.validations;

          EventBus.emit('recording-request-validated-or-rejected', { id: lastStatus.value.id, type: 'recording_request_validate'});

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          });
        })
        .finally(() => {
          loading.value = false;
        });
    }

    const removeCamerasUnit = (indexUnit, indexCamera) => {
      const unit = itemData.value.cameras[indexUnit];

      unit.cameras.splice(indexCamera, 1);

      if (!unit.cameras.length) {
        removeUnit(indexUnit);
      }
    }

    const removeUnit = (index) => {
      itemData.value.cameras.splice(index, 1);
    }

    const removeFileImageLogo = () => {
      dropzoneImageLogo.value = null;
    }

    const sendToReview = async () => {
      const payload = {
        id_recording_request: itemData.value.id,
        id_user_validation: userSelected.value
      }

      loading.value = true;

      await axios.post('v1/recording_request/validation', payload)
        .then(response => {
          const { data } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: 'CheckIcon',
              variant: 'success'
            },
          });

          itemData.value.validations = data.data.validations;
          itemData.value.last_validation = data.data.last_validation;

          buildCamerasFromApi(data.data.cameras);
        })
        .finally(() => {
          loading.value = false;
        });
    }

    return {
      getValidationState,
      refFormObserver,

      camerasByUnit,
      checkingAvailability,
      dropzoneImageLogo,
      dropzoneOptions,
      errorCameras,
      errorValidationComment,
      itemData,
      loading,
      loadingSearchRecordingRequest,
      showCamerasListModal,
      userOptions,
      userReopenedOptions,
      userSelected,
      userSelectedReasigned,
      validationComment,

      canEditForm,
      canUserSendToReopen,
      canUserSendToReview,
      disabledInputs,
      fields,
      isDark,
      recordingRequestWithValidations,
      showSaveButton,
      showValidateButtons,
      tagsOptions,

      addFileImageLogo,
      approve,
      back,
      filterUsers,
      formatDate,
      formatUser,
      getStatusLabel,
      getStatusVariant,
      getUserEmail,
      getUserLabel,
      getUserName,
      onChangeDates,
      onSubmit,
      reject,
      removeCamerasUnit,
      removeUnit,
      removeFileImageLogo,
      sendToReview
    }
  }
}
</script>

<style lang="scss" scoped>
.border-unit {
  border: 1px solid rgba(0, 0, 0, .125);
  width: 100%;
}

.timeNoBackground {
  border-radius: 0.3em;
  background-color: transparent;
  margin: 0;
  border-radius: 0.3em;
  border: 1px solid #cecece;
  background-color: transparent;
  padding: 0.75em;
  margin: 0;
}
.groupContainer {
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  padding: 5px;
  margin-bottom: 10px;
}
.text-error {
  color: #ec0303;
}
.form-container {
  height: calc(100vh - 150px);
  overflow-y: auto;
}

.comment-box {
  width: 450px;
}

/*info left, history right */
.header-grid {
  max-width: 850px;
}

@media (max-width: 992px) {
  .header-grid {
    grid-template-columns: 1fr;
  }
}

.info-card {
  background: #f9fafb;
  border: 1px solid #eceff3;
  border-radius: 8px;
  padding: 10px 12px;
}

.info-row {
  display: flex;
  gap: 6px;
  margin-bottom: 4px;
}

.info-label {
  font-weight: 600;
  color: #444;
}

.info-value {
  color: #111;
  text-transform: none !important;
}

.history-card { background: #fff; border: 1px solid #eceff3; border-radius: 8px; padding: 12px; overflow: hidden; min-width: 300px; }
.history-header { margin-bottom: 8px; }
.history-table { width: 100%; }
.history-row { display: grid;
  grid-template-columns: auto 1fr auto;
  column-gap: 8px;
  align-items: center;}
.history-row-item-container {
  border-bottom: 1px dotted #e0e0e0;
}
.history-row-item {  display: grid;
  grid-template-columns: auto 1fr auto;
  column-gap: 8px;
  align-items: center;
  padding: 10px 0;
}
.history-row-item__comments {
  font-size: 16px;
}
.history-row:last-child { border-bottom: 0; }
.history-row--head { border-bottom: 1px solid #e9ecef; font-weight: 600; color: #444; padding-top: 0; padding-bottom: 8px; }
.col-state { justify-self: start; }
.col-user { justify-self: start; min-width: 0; }
.col-date { justify-self: end; white-space: nowrap; overflow: visible; }
.history-row--head > div, .history-row > .col-user { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.col-note { white-space: normal; overflow: hidden; }
.history-badge { display: inline-flex; align-items: center; }
.history-date { font-size: 12px; color: #6c757d; font-variant-numeric: tabular-nums; }
.content-grid { display: block; }
</style>
